module.exports = __webpack_public_path__ + "img/interact_menu_prev_pc.3f54e128.png";